/*
 * A firm user viewing a client's portal ("View as client"). The preview lives
 * in this tab's sessionStorage so the firm app in other tabs is unaffected;
 * the server answers GETs as the client and refuses every write.
 */
import { CLIENT_PORTAL_PATH } from "./routes";

const KEY = "clientPortalPreview";
export const PREVIEW_PARAM = "preview";
export const PREVIEW_HEADER = "X-Client-Portal-Preview";

export const clientPortalPreview = (): string | null =>
  sessionStorage.getItem(KEY);

export const startClientPortalPreview = (clientId: string): void =>
  sessionStorage.setItem(KEY, clientId);

export const endClientPortalPreview = (): void =>
  sessionStorage.removeItem(KEY);

export const clientPortalPreviewUrl = (clientId: string): string =>
  `${CLIENT_PORTAL_PATH}?${PREVIEW_PARAM}=${encodeURIComponent(clientId)}`;
